import { Field } from 'react-final-form'
import { RadioGroup } from '@pokemon/design-v2.radio-group'
import { Radio } from '@pokemon/design-v2.radio-button'
import { Typography } from '@pokemon/design-v2.typography'
import { useTranslation } from 'react-i18next'
import { useMemo, useContext } from 'react'
import { AuthContext, AuthContextValue } from '../utils/auth/context'
import { Alert } from '@pokemon/design-v2.alert'
import { Stack } from '@pokemon/design-v2.stack'
import { Box } from '@mui/system'

export interface LeaderboardRadioGroupProps {
  readonly disabled?: boolean
}

export function LeaderboardRadioGroup (props: LeaderboardRadioGroupProps) {
  const { t } = useTranslation()
  const { loggedUserProfile } = useContext<AuthContextValue>(AuthContext)

  const firstName = loggedUserProfile?.first_name
  const lastName = loggedUserProfile?.last_name
  const screenName = loggedUserProfile?.screen_name

  const fieldProps = useMemo(() => ({
    type: 'radio',
    name: 'player_rankings_display',
    validate: (val: string) => {
      if (!val && !props.disabled) {
        return t('play_leaderboard_name_required', 'Leaderboard Display Name is required.')
      }
    }
  }), [props.disabled, t])

  return (
    <RadioGroup>
      <Stack spacing={2}>
        <Field {...fieldProps} value="fn" key={`fn-${props.disabled}`}>
          {({ input, meta }) => (
            <>
              {meta.touched && meta.error &&
                <Alert data-testid="play-missing-leaderboard-name-error" variant="outlined" severity="error">
                  {meta.error}
                </Alert>
              }

              <Box>
                <Radio
                  {...input}
                  {...props}
                  data-testid="play-rankings-fn"
                  label={t('first_name_last_name', 'First Name Last Name')} />
                {firstName && lastName && <Typography data-testid="play-rankings-example-fn" sx={{ marginLeft: 4 }}>{firstName} {lastName}</Typography>}
              </Box>
            </>
          )}
        </Field>

        <Field {...fieldProps} value="fnli" key={`fnli-${props.disabled}`} >
          {({ input }) => (
            <Box>
              <Radio
                {...input}
                {...props}
                data-testid="play-rankings-fnli"
                label={t('first_name_last_initial', 'First Name Last Initial')} />
              {firstName && lastName && <Typography data-testid="play-rankings-example-fnli" sx={{ marginLeft: 4 }}>{firstName} {lastName[0]}.</Typography>}
            </Box>
          )}
        </Field>

        <Field {...fieldProps} value="sn" key={`sn-${props.disabled}`}>
          {({ input }) => (
            <Box>
              <Radio
                {...input}
                {...props}
                data-testid="play-rankings-sn"
                label={t('screen_name', 'Screen Name')} />
              {screenName && <Typography data-testid="play-rankings-example-sn" sx={{ marginLeft: 4 }}>{screenName}</Typography>}
            </Box>
          )}
        </Field>
      </Stack>
    </RadioGroup>
  )
}
